var _g, _path, _g2, _path2, _g3, _g4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCampfirePoints50(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 180,
    viewBox: "10 10 125 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.464 176.918C74.464 176.918 96.1313 174.591 108.136 165.864C120.14 157.138 133.31 140.554 131.847 118.45C130.383 96.3454 124.819 91.3964 124.819 91.3964C124.819 91.3964 121.305 104.488 115.742 102.159C110.179 99.8295 118.091 61.7739 108.136 48.0973C98.1807 34.4206 70.0665 12.1714 70.0665 12.1714C70.0665 12.1714 71.5204 49.7898 64.7861 53.8631C58.0518 57.9363 54.2554 63.1797 51.3278 69.2889C48.4003 75.3982 49.283 110.494 39.3224 110.494C29.3618 110.494 27.6112 89.6527 27.6112 89.6527C27.6112 89.6527 14.1414 108.559 14.7276 122.23C15.3138 135.902 33.4719 157.72 33.4719 157.72L23.517 155.689C23.517 155.689 39.6155 176.918 74.464 176.918Z",
    fill: "url(#paint0_radial)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1814 87.4296C37.1814 87.4296 42.8609 77.2292 43.41 71.9541C43.9591 66.679 41.8875 55.973 41.1882 56.9583C33.1106 67.8901 34.4181 75.984 37.1814 87.4296Z",
    fill: "#FF6320"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.4669 170.856C66.4669 170.856 83.5663 175.326 98.1914 163.256C106.818 156.196 114.596 148.17 121.37 139.338L109.669 142.246C109.669 142.246 109.441 130.396 112.367 123.244C115.292 116.092 115.516 110.49 103.74 118.79C102.227 119.857 91.2162 116.759 93.9165 98.879C96.6169 80.9993 90.5414 63.7787 80.4172 53.5015C80.4172 63.3374 57.4696 75.6315 56.3427 93.5135C55.2158 111.395 53.4356 145.154 28.4512 120.338C28.4512 144.255 48.018 168.62 66.4669 170.856Z",
    fill: "#FE9A3D"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5218 167.279C79.8872 170.717 100.688 160.61 101.795 146.043C103.596 137.773 103.146 132.855 97.9715 128.384C83.9541 116.948 81.214 85.623 83.7974 72.1235C56.5965 97.7716 74.9489 109.865 59.724 127.939C51.6219 133.75 38.3475 131.514 37.2228 135.314C36.0982 139.114 54.5471 166.385 70.5218 167.279Z",
    fill: "#FFB22D"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9154 165.496C86.1723 165.311 95.2729 150.52 93.4735 142.698C91.674 134.877 79.3005 125.032 78.4008 115.644C77.501 106.256 78.1736 102.305 78.1736 102.305C78.1736 102.305 71.8834 113.856 69.9658 121.232C68.0482 128.607 66.0238 139.115 61.5241 140.456C57.0243 141.796 49.5959 139.115 51.3987 142.915C53.2016 146.715 61.3094 165.715 74.9154 165.496Z",
    fill: "#FFE840"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9199 163.014C83.7888 163.014 86.9333 150.721 86.1267 145.377C85.3201 140.032 74.2053 131.212 74.9199 128.54C75.6344 125.867 72.9466 140.833 68.1038 142.97C63.2609 145.108 58.4203 145.905 60.3027 150.719C62.1851 155.534 66.8746 163.014 74.9199 163.014Z",
    fill: "#FDFBE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 4.70898,
    y: 0.171387,
    width: 137.249,
    height: 184.747,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.610667 0 0 0 0 0.391667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 0.451172,
    y: 27.5015,
    width: 148.918,
    height: 174.164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 14
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.443137 0 0 0 0 0.231373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 47.1221,
    y: 98.3047,
    width: 50.5794,
    height: 71.1936,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.909804 0 0 0 0 0.25098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f",
    x: 56.8867,
    y: 125.221,
    width: 32.3616,
    height: 40.7923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.3337 102.305) rotate(-72.4347) scale(55.713 46.5056)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F87A1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F83D1F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampfirePoints50);
export default __webpack_public_path__ + "static/media/campfire-points-50.2c5b5edcc6d99e11fdd89eab4bac3e0a.svg";
export { ForwardRef as ReactComponent };